import { ADD_TASK, ADD_TASKS, FETCH_TASKS, UPDATE_TASK, REMOVE_TASK } from '../actions/index';

export default function(state = {}, action) {
  switch (action.type) {
  case FETCH_TASKS:
    return action.payload;
  case ADD_TASK:
    return [...state, action.payload];
  case ADD_TASKS:
    return [...state, ...action.payload];
  case UPDATE_TASK: {
    const updatedTask = action.payload;
    return state.map(task => task.id === updatedTask.id ? updatedTask : task);
  }
  case REMOVE_TASK:
    return state.filter(task => task.id !== action.payload);
  default:
    return state;
  }
}
